import axios from 'axios';
import { Logger, LOG_LEVEL } from './logger';

export class FlingService {
  constructor (baseURl, logger=new Logger(LOG_LEVEL.NONE)) {
    this._baseUrl = baseURl;
    this._logger = logger;
    this._logger.debug(`Fling Service Running @ ${this._baseUrl}`);
    this._options = {
      headers: {},
    };
    this._st = 'wzB3JXICIK';
  }
  
  _loggerInstance = function () {
    return this._logger;
  };
  
  _getServiceUrl = function () {
    return this._baseUrl;
  }; 

  _urlBuilder(baseUrl, path, queryString) {
    let _burl = new URL('', baseUrl);
    let _path = `${_burl.pathname}${path}`.replace('//', '/');
    return new URL(`${_path}${queryString}`, _burl.origin);
  }

  async _post(path, data={}, qs=undefined, options={}) {
    // Call from within fling api only!
    try {
      let url = this._urlBuilder(this._getServiceUrl(), path, qs === undefined ? '' : `?${qs}`).href;
      this._loggerInstance().debug(`POST ${url} data:${JSON.stringify(data)} options:${JSON.stringify(options)}`);
      let result = await axios.post(url, data, options);
      return result;
    } catch (e) {
      this._loggerInstance().error('An error occurred making a request to the server: ', e);
      // If unauthorized, remove access token
      if (e.response.status > 399 && e.response.status < 500) {
        localStorage.removeItem(this._st);
        delete this._options.headers.grant;
      }

      return e.response;
    }
  }

  _isSuccess(responseStatus) {
    return responseStatus === 'Success';
  }

  _handleCallbacks(response, callback={ onErr: undefined, onSuccess: undefined }) {
    this._loggerInstance().debug(response);
    if (typeof(callback) !== typeof({})) callback = {};

    let requestSuccess = this._isSuccess(response.data.status);
    if (requestSuccess && typeof(callback.onSuccess) === typeof(()=>{})) {
      callback.onSuccess(response);
    }

    if (!requestSuccess && typeof(callback.onErr) === typeof(()=>{})) {
      callback.onErr(response);
    }
  }

  restoreLocalSession() {
    let sessionToken = localStorage.getItem(this._st);
    if (sessionToken) {
      this._options.headers.grant = sessionToken;
      return true;
    }
    return false;
  }

  async authorized(callback) {
    let result = await this._post('/authorize', null, undefined, this._options);
    this._handleCallbacks(result, callback);
    return result;
  }

  async broadcast(payload, callback) {
    let result = await this._post('/broadcast', payload, undefined, this._options);
    this._handleCallbacks(result, callback);
    return result;
  }

  async authorizeByDeviceCode(code, callback) {
    let result = await this._post(`/authorize/${code}`, null, undefined, this._options);
    this._handleCallbacks(result, {
      onErr: (callback || {}).onErr,
      onSuccess: (args) => {
        localStorage.setItem(this._st, args.headers.grant);
        this._options.headers.grant = args.headers.grant;
        (callback || {}).onSuccess(args);
      }
    });
    return result;
  }

  link(storeId, callback) {
    let payload = { location: `${storeId}`};
    let result = this._post('/link', payload);
    this._handleCallbacks(result, callback);
    return result;
  }
}